import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { PAUSE_CAMPAIGN, PAUSE_CAMPAIGN_SUCCESS, PAUSE_CAMPAIGN_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* pauseCampaign({ payload }) {
  const { campaignId } = payload;
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/campaigns/${campaignId}/status`,
      method: 'PATCH',
      data: payload.data,
      isFormData: true,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: PAUSE_CAMPAIGN_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: PAUSE_CAMPAIGN_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: PAUSE_CAMPAIGN_ERROR, payload: error });
  }
}

export function* watchPauseCampaign() {
  yield takeEvery(PAUSE_CAMPAIGN, pauseCampaign);
}

function* pauseCampaignSaga() {
  yield all([fork(watchPauseCampaign)]);
}

export default pauseCampaignSaga;
